import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { type FileData, FileType } from '../types';
import Layout from './Layout';

export let Viewer = () => {
  let [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 768);
  let [selectedFile, setSelectedFile] = useState<FileData | null>(null);

  let [search] = useSearchParams();
  let repo = search.get('repo');
  let owner = search.get('owner');
  let path = search.get('path');
  let title = search.get('title');
  let initialFile = search.get('initial_file');
  let replacementsRaw = search.get('replacements');
  let replacements: Record<string, string> = replacementsRaw
    ? JSON.parse(atob(replacementsRaw))
    : {};

  let toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  let handleFileSelect = (file: FileData) => {
    if (file.type !== FileType.DIRECTORY) {
      setSelectedFile(file);
      if (window.innerWidth < 768) {
        setSidebarOpen(false);
      }
    }
  };

  let [files, setFiles] = useState<FileData[]>([]);

  useEffect(() => {
    if (!repo || !owner || !path) {
      setFiles([]);
      return;
    }

    (async () => {
      let url = new URL('https://metorial-code-viewer.pages.dev/api/get_code');
      url.searchParams.set('repo', repo);
      url.searchParams.set('owner', owner);
      url.searchParams.set('path', path);

      let res = await fetch(url);
      if (res.ok) {
        let data = (await res.json()) as {
          files: FileData[];
        };
        setFiles(data.files || []);

        let getFlatFiles = (files: FileData[]): FileData[] =>
          files.flatMap(f => {
            if (!f.children) return [f];
            return [f, ...getFlatFiles(f.children)];
          });
        let flatFiles = getFlatFiles(data.files);

        if (initialFile) {
          let initial = flatFiles.find(f => f.name === initialFile || f.id === initialFile);
          if (initial) setSelectedFile(initial);
        }
      }

      let spinner = document.querySelector('.spinner') as HTMLDivElement | null;
      if (spinner) {
        spinner.style.opacity = '0';
        spinner.style.pointerEvents = 'none';
        setTimeout(() => {
          spinner.remove();
        }, 300);
      }
    })();
  }, [repo, owner, path]);

  return (
    <Layout
      sidebarOpen={sidebarOpen}
      toggleSidebar={toggleSidebar}
      files={files}
      selectedFile={selectedFile}
      onFileSelect={handleFileSelect}
      title={title || undefined}
      replacements={replacements}
    />
  );
};
